/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_PasswordInputs */

const cs_settings_profile_password = /** @type {(inputs: Settings_Profile_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změna hesla`)
};

const en_settings_profile_password = /** @type {(inputs: Settings_Profile_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change password`)
};

/**
* | output |
* | --- |
* | "Change password" |
*
* @param {Settings_Profile_PasswordInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_password = /** @type {((inputs?: Settings_Profile_PasswordInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_PasswordInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_password(inputs)
	return cs_settings_profile_password(inputs)
});